<!-- 头部导航组件 -->
<template>
	<div class="header">
		<!-- <div class="menu" @click="auditApply">审核</div> -->
		<div class="content flex-row">
			<div class="mall-name" @click="toHome">{{ mallTitle || $t('common.Header.031511-11') }}</div>
			<div class="menu-group flex-row flex-center">
				<div class="menu" @click="toHome">{{ $t('common.Header.031511-0') }}</div>
				<div
					class="menu program-menu flex-row"
					v-if="programQrcode"
					@mouseenter="showQrcode = true"
					@mouseleave="showQrcode = false"
				>
					<img class="img" src="./../../assets/images/icon-wx.png" />
					<div>{{ $t('common.Header.031511-1') }}</div>
					<img class="qrcode-img" v-show="showQrcode" :src="programQrcode" />
				</div>
				<div class="menu" v-if="!isLogin" @click="showLoginDialog">{{ $t('common.Header.031511-2') }}</div>
				<!-- <div class="menu" v-else>
					<el-dropdown placement="bottom" @command="handleCommand">
						<span class="el-dropdown-link personal-menu-txt" @click="toMine">
							个人中心
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="logout">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div> -->
				<div class="menu" @click="toShopCart">{{ $t('common.Header.031511-3') }}（{{ shopCartCount }}）</div>
				<div class="menu" v-if="!!customerName">
					<el-dropdown placement="bottom" @command="handleCommand">
						<div @click="toMine" class="el-dropdown-link personal-menu-txt">
							{{ customerName || $t('common.Header.031511-4') }}
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-if="isShowCustomerBalance">
								{{ $t('common.Header.031511-5') }} {{ $currency.symbol }}{{ customerBalance }}
								<span class="recharge-btn" @click="toRecharge">{{ $t('common.Header.031511-6') }}</span>
							</el-dropdown-item>
							<el-dropdown-item v-if="debtAmountMax > 0 && pcIsOpenDebtPay">
								{{ $t('common.Header.031511-7') }}{{ $currency.symbol }}{{ debtAmountMax }}
							</el-dropdown-item>
							<el-dropdown-item v-if="isLogin" command="logout">{{ $t('common.Header.031511-8') }}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<language-switcher class="menu" theme="dark"></language-switcher>
			</div>
		</div>

		<!-- 登录弹窗 -->
		<login-dialog
			v-if="isShowLoginDialog"
			ref="loginDialog"
			:isShow="isShowLoginDialog"
			:showClose="isLoginShowClose"
			@close="closeLoginDialog"
		></login-dialog>

		<!-- 登录弹窗 -->
		<float-loginandapply-tips :lock-scroll="false" @refreshUserName="closeLoginDialog"></float-loginandapply-tips>

		<!-- 充值弹窗 -->
		<recharge v-if="isShowRecharge" :isShow.sync="isShowRecharge"></recharge>
	</div>
</template>

<script>
	import LoginDialog from "./LoginDialog.vue";
	import FloatLoginAndApplyTips from "./FloatLoginAndApplyTips.vue";
	import Recharge from "./Recharge.vue";
	import LanguageSwitcher from "./LanguageSwitcher.vue";
	import { getCustomerInfo, auditCustomerApply } from "../../utils/api-utils/api-customer.js";
	import { getParam } from "../../utils/api-utils/api-params.js";
	import { getShoppingCartCount } from "../../utils/api-utils/api-goods-shoppingcart.js";
	import { system } from "../../utils/api-utils/api-sys.js";
	import request from "../../utils/request-utils.js";
	import { LOCALE_STORAGE_KEY } from "../../i18n";
	export default {
		name: "v-header",
		components: {
			"login-dialog": LoginDialog,
			"float-loginandapply-tips": FloatLoginAndApplyTips,
			recharge: Recharge,
			"language-switcher": LanguageSwitcher,
		},
		inject: ["reload"], // 引用父组件传过
		data() {
			return {
				mallTitle: "", //商城名
				programQrcode: "", //小程序二维码
				showQrcode: false, // 是否展示二维码
				shopCartCount: 0, // 购物车数量
				isShowLoginDialog: false, // 是否显示登录弹窗
				isLoginShowClose: true, //登录弹窗是否显示关闭按钮
				isLogin: false, // 是否登录的标记
				customerId: "", // 当前登录会员ID
				customerName: "", // 当前用户名
				customerBalance: "0.00", //用户余额
				debtAmountMax: "0.00",
				isOpenMultiShopCart: false, // 多购物车
				pcIsOpenDebtPay: false,
				isShowCustomerBalance: false, // 是否展示用户预存款
				isShowRecharge: false, // 是否显示充值弹窗
			};
		},
		created: async function () {
			// 获取用户信息
			let customerInfo = await getCustomerInfo();
			if (customerInfo.phone) {
				this.customerId = customerInfo.customerId;
				this.customerName = customerInfo.nickname;

				// 获取账户余额
				this.getBalance();
			}

			// 判断是否已经登录
			this.setIsLogin(customerInfo);

			//获取商城名称及小程序图片
			this.getMallInfo();
			//统计购物车数量
			this.countShopCart();
		},
		mounted() {
			//监听购物车数量变化
			this.$eventBus.$on("updateHeaderShopCartCount", () => {
				this.countShopCart();
			});

			//监听余额变化
			this.$eventBus.$on("updateHeaderBalance", () => {
				this.getBalance();
			});
			this.$eventBus.$on("updateBalanceByRecharge", () => {
				this.getBalance();
			});

			//监听登录弹窗是否显示,是否可关闭
			this.$eventBus.$on("showLoginDialog", (showLogin, showClose, passwordSetupCustomer) => {
				// 已登录用户刷新后被要求改密，直接打开已有的完善信息弹窗
				if (showLogin && passwordSetupCustomer) {
					this.isShowLoginDialog = true;
					this.isLoginShowClose = showClose;
					this.$nextTick(() => {
						this.$refs.loginDialog.openPasswordSetup(passwordSetupCustomer);
					});
					return;
				}

				// 未注册用户需要打开申请表单
				if (!this.isLogin && !!localStorage.getItem("telForRegister")) {
					this.$eventBus.$emit("showApplyForm");
					return;
				}

				this.isShowLoginDialog = showLogin;
				this.isLoginShowClose = showClose;
			});
		},
		methods: {
			//商城首页
			toHome() {
				this.$router.push({
					name: "home",
				});
			},
			//个人中心
			toMine() {
				this.$router.push({
					name: "tradelist",
				});
			},
			//购物车
			toShopCart() {
				this.$router.push({
					name: "shopcart",
				});
			},
			// 获取商城名称
			async getMallInfo() {
				// 判断是否开启了多购物车
				let paramlist = await getParam(
					"isOpenMultiShopCart,pcmall_title,program_qrcode_url_formal,pc_isOpenDebtPay,isShowCustomerBalance,miniProgramInfo,isOpenLoginLimit,loginLimitType"
				);

				// 获取小程序信息
				let miniProgramInfo = JSON.parse(paramlist.miniProgramInfo || "{}");

				this.isOpenMultiShopCart = paramlist.isOpenMultiShopCart == "1";
				this.mallTitle = paramlist.pcmall_title || this.$t("common.Header.031511-11");
				this.programQrcode = miniProgramInfo.qrcodeImgUrl || "";
				this.pcIsOpenDebtPay = paramlist.pc_isOpenDebtPay == "1";
				this.isShowCustomerBalance = paramlist.isShowCustomerBalance == "1";
				this.isOpenLoginLimit = paramlist.isOpenLoginLimit == "1";
				this.loginLimitType = paramlist.loginLimitType;
			},
			// 获取购物车数量
			async countShopCart() {
				let shopCartCount = await getShoppingCartCount();
				//获取到最新的购物车数量，修改头部购物车数量
				this.shopCartCount = shopCartCount || 0;
				//修改浮动按钮购物车数量
				this.$eventBus.$emit("updateFloatShopCartCount", this.shopCartCount);
			},

			/**
			 * 判断是否已经登录
			 */
			setIsLogin(customerInfo) {
				this.isLogin = customerInfo.phone;
			},

			/**
			 * 显示登录弹窗
			 */
			showLoginDialog() {
				this.isShowLoginDialog = true;
			},

			/**
			 * 关闭登录弹窗（下级调用） 登录成功也会调这个
			 */
			async closeLoginDialog({ isJustClose, isNeedShowApplyForm } = {}) {
				this.isShowLoginDialog = false;

				// 仅关闭时 直接返回
				if (isJustClose) {
					return;
				}

				// 获取用户信息
				let customerInfo = await getCustomerInfo();
				if (customerInfo.phone) {
					this.customerId = customerInfo.customerId;
					this.customerName = customerInfo.nickname;
				}

				// 判断是否已经登录
				this.setIsLogin(customerInfo);

				//获取商城名称及小程序图片
				this.getMallInfo();
				//统计购物车数量
				this.countShopCart();
				// 获取账户余额
				this.getBalance();

				this.reload();

				// 设置cuustomerId
				this.$eventBus.$emit("setCustomerId", localStorage.getItem("pc_customerId"));

				// 展示申请表单
				if (isNeedShowApplyForm) {
					this.$eventBus.$emit("showApplyForm");
				}
			},

			/**
			 * 处理下拉菜单命令
			 */
			handleCommand(command) {
				//退出登录
				if (command == "logout") {
					this.$confirm(this.$t("common.Header.031511-9"), this.$t("common.Header.031511-10"), {
						confirmButtonText: this.$t("common.action.confirm"),
						cancelButtonText: this.$t("common.action.cancel"),
					}).then(() => {
						this.logout(true);
					});
				}
			},

			/**
			 * 获得账户余额
			 */
			async getBalance() {
				let that = this;
				// 获取余额数据
				let balance = await that.$public.getCustomerBalance();
				that.customerBalance = balance;
				let customerInfo = await getCustomerInfo();
				balance = parseFloat(that.customerBalance);
				let debtAmountMax =
					customerInfo && customerInfo.debtAmountMax ? parseFloat(customerInfo.debtAmountMax || 0) : 0;
				if (debtAmountMax == 0) {
					that.debtAmountMax = "0.00";
					return;
				}
				if (balance > 0) {
					that.debtAmountMax = debtAmountMax.toFixed(2);
				} else {
					that.debtAmountMax = (balance + debtAmountMax).toFixed(2);
				}
			},

			async logout(isFromHeader) {
				//清除缓存用户信息，回到首页
				const savedLocale = localStorage.getItem(LOCALE_STORAGE_KEY);
				localStorage.clear();
				if (savedLocale) {
					localStorage.setItem(LOCALE_STORAGE_KEY, savedLocale);
				}

				// 停止登录态 token 刷新定时器（用户已登出，无需再续 token）
				if (request.stopUserTokenRefreshTimer) {
					request.stopUserTokenRefreshTimer();
				}

				// 立即清掉登录态 token 后，立刻补一个游客态 token 到 pc_accessToken_toCLogin
				// 避免退出登录后刷新页面 / 继续浏览时，jkymini 请求还带着登录人的旧 token 被网关拦截
				// localStorage.clear() 也会清掉 pc_jmall_api_version，需要先 getJmallApiVersion 重新写入
				// 必须 await 完成后再跳转首页，否则首页发起的 jkymini 请求会抢跑在没有 token 的状态下被网关拦截
				if (request.pcUseJkymini && request.getJmallApiVersion && request.visitFakeLogin) {
					try {
						await request.getJmallApiVersion();
						await request.visitFakeLogin();
						console.log('[退出登录] 游客态 token 已重新就位');
					} catch (err) {
						console.warn('[退出登录] 游客态登录失败，jkymini 网关可能走不通：', err);
					}
				}

				this.getSysParams();
				this.isLogin = false;
				this.customerId = "";
				this.customerName = "";
				this.customerBalance = "0.00";
				system.setDistributorId("");
				system.setCustomerId("");

				//统计购物车数量
				this.countShopCart();

				// 设置customerId
				this.$eventBus.$emit("setCustomerId", localStorage.getItem("pc_customerId"));

				if (
					this.$route.name == "home" &&
					this.isOpenLoginLimit &&
					["auditLimitOfPrice", "auditLimitOfPersonalInfo"].includes(this.loginLimitType)
				) {
					location.reload();
				} else {
					this.$router.push({
						name: "home",
					});
					setTimeout(() => {
						this.showLoginDialog();
					}, 400);
				}

				if (isFromHeader) {
					const channel = new BroadcastChannel("jmall-memberName");
					channel.postMessage("");
					channel.close();
				}
			},

			/**
			 * 获取系统配置参数，渠道仓库等
			 */
			async getSysParams() {
				let _this = this;
				let paramlist = await getParam(
					"bindSaleChannelId,bindSaleChannelName,bindWarehouseId,defaultMemberGradeId,defaultMemberGradeName,commission_mode,pc_goodsDetailStyle,currencySymbol"
				);
				// 绑定的吉客云渠道ID
				localStorage.setItem("pc_channelId", paramlist.bindSaleChannelId);
				// 获取到店铺Id后，获取购物车总数
				this.$eventBus.$emit("updateHeaderShopCartCount");
				// 绑定的吉客云渠道名称
				localStorage.setItem("pc_channelName", paramlist.bindSaleChannelName);
				// 默认仓库ID
				localStorage.setItem("pc_warehouseId", paramlist.bindWarehouseId);
				// 默认会员等级ID
				localStorage.setItem("pc_defaultMemberGradeId", paramlist.defaultMemberGradeId);
				// 默认会员等级名称
				localStorage.setItem("pc_defaultMemberGradeName", paramlist.defaultMemberGradeName);
				// 分销模式
				localStorage.setItem("pc_commissionMode", paramlist.commission_mode ? paramlist.commission_mode : "");
				// 商品详情样式
				localStorage.setItem(
					"pc_goodsDetailStyle",
					paramlist.pc_goodsDetailStyle ? paramlist.pc_goodsDetailStyle : 0
				);
				// 币种符号
				_this.$currency.setSymbol(paramlist.currencySymbol || "￥");
			},

			auditApply() {
				auditCustomerApply("10", 1);
			},

			/**
			 * 充值
			 */
			toRecharge() {
				this.isShowRecharge = true;
			},
		},
		computed: {},
	};
</script>

<style scoped="scoped">
	.header {
		width: 100vw;
		height: 50px !important;
	}

	.content {
		width: 100%;
		height: 100%;
		background-color: #000000;
		color: #fff;
		font-size: 15px;
		justify-content: space-between;
		align-items: center;
	}

	.mall-name {
		margin-left: 20px;
		cursor: pointer;
	}

	.img {
		height: 18px;
		width: 18px;
		margin: 1px 10px;
	}

	.menu-group {
		height: 100%;
	}

	.menu {
		margin: 0 20px;
		cursor: pointer;
		position: relative;
	}

	.program-menu {
		height: 100%;
		align-items: center;
	}

	.qrcode-img {
		position: absolute;
		width: 300px;
		height: 300px;
		top: 50px;
		left: -100px;
		border: solid 1px #ccc;
	}

	.btn-logout {
		position: absolute;
	}

	.personal-menu-txt {
		color: #fff !important;
		/* width: 200px; */
		height: 23px;
		line-height: 23px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		margin-right: 30px;
		margin-top: 4px;
	}

	.recharge-btn {
		margin-left: 10px;
		color: #00c0ef;
	}

	.recharge-btn:hover {
		text-decoration: underline;
	}
</style>
